module.exports = __webpack_public_path__ + "static/media/banner-dia-das-maes.7b9df8dc.jpg";